import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('ReportTypeFilterController', ReportTypeFilterController);

    function ReportTypeFilterController() {
        var vm = this;
        var REPORT_TYPES = {
            SIMPLE: 'simple',
            MATERIALS: 'materials',
            EXTENDED_MATERIALS: 'extended_materials',
        };

        vm.reportTypes = [
            {
                display: 'Raport bez materiałów',
                value: REPORT_TYPES.SIMPLE,
            },
            {
                display: 'Raport z materiałami',
                value: REPORT_TYPES.MATERIALS,
            },
            {
                display: 'Szczegółowy raport z materiałami',
                value: REPORT_TYPES.EXTENDED_MATERIALS,
            },
        ];

        vm.reportType = REPORT_TYPES.SIMPLE;
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/filters/report-type/report-type-filter.controller.ts